import React from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import {
  Home,
  ClipboardList,
  PlusCircle,
  Settings,
  X,
  ArrowLeft,
  Activity,
  Sparkles
} from 'lucide-react'

const navItems = [
  { path: '/', label: 'Dashboard', icon: Home },
  { path: '/surveys', label: 'All Surveys', icon: ClipboardList },
  { path: '/survey/new', label: 'New Survey', icon: PlusCircle },
  { path: '/activity', label: 'Activity', icon: Activity },
  { path: '/ai-prompts', label: 'AI Prompts', icon: Sparkles },
  { path: '/settings', label: 'Settings', icon: Settings }
]

export default function Sidebar({ isOpen, onClose }) {
  const location = useLocation()
  const navigate = useNavigate()

  // Show back button on any page except Dashboard
  const showBackButton = location.pathname !== '/'

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed top-0 left-0 h-full w-64 bg-white shadow-xl z-50
          transform transition-transform duration-300 ease-in-out
          lg:translate-x-0 lg:sticky lg:top-0 lg:w-48 lg:h-[calc(100vh-64px)] lg:shadow-none lg:border-r lg:border-slate-200 lg:z-auto
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
      >
        {/* Mobile header */}
        <div className="flex items-center justify-between p-4 border-b border-slate-200 lg:hidden">
          <img
            src="https://cdn.prod.website-files.com/692966ae0a71b2cba119f627/6929802260ae20ce6dfade6f_card-logo.avif"
            alt="Clystcore Surveyors"
            className="h-10 w-auto"
          />
          <button
            onClick={onClose}
            className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
            aria-label="Close menu"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="p-3 lg:p-2 lg:pt-4 flex flex-col h-[calc(100%-60px)] lg:h-[calc(100%-16px)]">
          <ul className="space-y-1">
            {navItems.map((item) => {
              const Icon = item.icon
              const isActive = location.pathname === item.path

              return (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    onClick={onClose}
                    className={`
                      flex items-center gap-3 px-4 py-3 rounded-lg
                      lg:gap-2 lg:px-3 lg:py-2 lg:text-sm
                      font-medium transition-colors duration-200
                      ${isActive
                        ? 'bg-primary-50 text-primary-700'
                        : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
                      }
                    `}
                  >
                    <Icon className="w-5 h-5 lg:w-4 lg:h-4" />
                    {item.label}
                  </NavLink>
                </li>
              )
            })}
          </ul>

          {/* Spacer */}
          <div className="flex-1" />

          {/* Back button - shown on any page except Dashboard */}
          {showBackButton && (
            <div className="border-t border-slate-200 pt-3 mt-3">
              <button
                onClick={() => {
                  navigate(-1)
                  onClose()
                }}
                className="flex items-center gap-3 px-4 py-3 rounded-lg w-full
                  lg:gap-2 lg:px-3 lg:py-2 lg:text-sm
                  font-medium transition-colors duration-200
                  text-slate-600 hover:bg-slate-50 hover:text-slate-900"
              >
                <ArrowLeft className="w-5 h-5 lg:w-4 lg:h-4" />
                Back
              </button>
            </div>
          )}
        </nav>

      </aside>
    </>
  )
}
